import PropTypes from 'prop-types';

export const parserPropTypes = {
    name: PropTypes.string,
    type: PropTypes.string,
    attribs: PropTypes.object,
    children: PropTypes.array
}
export const parserPropTypesDefaults = {
    name: null,
    type: null,
    attribs: null,
    children: null
}